import { Menu, Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import { Fragment, ReactNode } from "react";

export default function FilterDropdown({
  name,
  children,
  onSubmit,
  onClear,
  active = false,
}: {
  name: string;
  children: ReactNode;
  onSubmit: (close: () => void) => void;
  onClear: (close: () => void) => void;
  active?: boolean;
}) {
  return (
    <Popover as="div" className="relative inline-block">
      {({ close }) => (
        <>
          <div>
            <Popover.Button
              className={clsx(
                "group inline-flex justify-center text-sm font-medium"
              )}
            >
              {name}
              <ChevronDownIcon
                className={clsx("-mr-1 ml-1 h-5 w-5 flex-shrink-0")}
                aria-hidden="true"
              />
            </Popover.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              className="absolute left-1/2 z-50 mt-2 w-max origin-top rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none lg:-translate-x-1/2"
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  onSubmit(close);
                }}
                className="space-y-2 p-4"
              >
                {children}
                <div className="space-x-1">
                  <button
                    type="submit"
                    className="inline-flex items-center rounded-md border border-transparent bg-slate-900 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2"
                  >
                    Apply
                  </button>
                  {active && (
                    <button
                      type="button"
                      onClick={() => onClear(close)}
                      className="inline-flex items-center rounded-md border border-transparent bg-red-100 px-3 py-2 text-sm font-medium leading-4 text-red-700 shadow-sm hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                    >
                      Clear
                    </button>
                  )}
                </div>
              </form>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
